module.exports = __webpack_public_path__ + "static/media/bg3.b5b08cb4.jpg";